/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from "@ember/object";
import { tracked } from "@glimmer/tracking";
import { Changeset, EmberChangeset } from "ember-changeset";
import ModelListComponent, { ModelListItem, ModelListComponentSignature } from "../model-list";
/**
 * This component helps handle list of things in a component.
 * This helper provides the logic for handling lists:
 * - adding an item,
 * - deleting one,
 * - moving items (coming later).
 *
 * The model is usually a changeset.
 */
let ModelListWithModalComponent = (_class = class ModelListWithModalComponent extends ModelListComponent {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "showModal", _descriptor, this);
    _defineProperty(this, "modalChangeset", void 0);
    this.modalChangeset = Changeset({});
  }
  onModalValidated() {
    this.showModal = !this.showModal;
    this.modalChangeset.execute();
    this.addItemObject({
      ...this.modalChangeset.data
    });
    /**
     * The rollback method of the changeset do not propagate changes.
     * So we have to set every key to undefined to propagate to the modal form
     */
    this.modalChangeset.changes.forEach(change => this.modalChangeset.set(change.key, undefined));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "showModal", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "onModalValidated", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onModalValidated"), _class.prototype), _class);
export { ModelListWithModalComponent as default };